export const SERVICE_MODE_OPTIONS = [
  { value: 'puntual', label: 'Puntual' },
  { value: 'por_viaje', label: 'Por viaje' },
  { value: 'abono', label: 'Abono' },
];

export const SERVICE_CONTRACT_MODEL_OPTIONS = [
  {
    value: 'trip_rate',
    label: 'Por viaje',
    description: 'Cada viaje se liquida por separado y al cierre del mes se consolida el detalle.',
  },
  {
    value: 'monthly_fixed',
    label: 'Abono fijo',
    description: 'El cliente paga un valor mensual fijo aunque la cantidad de viajes cambie dentro del acuerdo.',
  },
  {
    value: 'monthly_variable',
    label: 'Mensual variable',
    description: 'El cliente paga por mes según la cantidad real de viajes realizados durante el período.',
  },
];

export const SERVICE_PRICING_RULE_OPTIONS = [
  {
    value: 'manual_total',
    label: 'Precio manual',
    description: 'La empresa define directamente cuánto se cobra por el viaje o servicio.',
  },
  {
    value: 'fixed_margin',
    label: 'Margen fijo',
    description: 'Al costo operativo real se le suma un monto fijo de ganancia.',
  },
  {
    value: 'percentage_margin',
    label: 'Porcentaje sobre costo',
    description: 'La ganancia se calcula como porcentaje del costo operativo del viaje.',
  },
];

export const SERVICE_MARGIN_PRESET_OPTIONS = [
  { value: 'economica', label: 'Competitiva', percent: 30, description: 'Propuesta ajustada para clientes sensibles a precio.' },
  { value: 'normal', label: 'Estándar', percent: 40, description: 'Referencia base recomendada para la mayoría de los viajes.' },
  { value: 'premium', label: 'Premium', percent: 60, description: 'Propuesta más alta para urgencias o servicios especiales.' },
  { value: 'manual', label: 'Manual', percent: null, description: 'Definís el porcentaje exacto para este cliente o viaje.' },
];

export const resolveMarginPresetPercent = (preset = 'normal') => {
  const matched = SERVICE_MARGIN_PRESET_OPTIONS.find((option) => option.value === preset);
  if (!matched) return 40;
  return Number.isFinite(Number(matched.percent)) ? Number(matched.percent) : 40;
};

export const inferMarginPreset = (marginPercent = 0) => {
  const normalized = Number(marginPercent || 0);
  if (!Number.isFinite(normalized) || normalized <= 0) return 'normal';

  const matched = SERVICE_MARGIN_PRESET_OPTIONS.find(
    (option) => Number.isFinite(Number(option.percent)) && Number(option.percent) === normalized
  );

  return matched ? matched.value : 'manual';
};

export const SERVICE_TRANSPORT_OPTIONS = [
  { value: 'moto', label: 'Moto' },
  { value: 'auto', label: 'Auto' },
  { value: 'camioneta', label: 'Camioneta' },
  { value: 'camion', label: 'Camión' },
];

export const SERVICE_TASK_OPTIONS = [
  { value: 'retiro', label: 'Retiro' },
  { value: 'entrega', label: 'Entrega' },
  { value: 'retiro_entrega', label: 'Retiro y entrega' },
  { value: 'tramite', label: 'Trámite' },
  { value: 'paquete', label: 'Paquete' },
  { value: 'documentacion', label: 'Documentación' },
  { value: 'cobranza', label: 'Cobranza' },
  { value: 'otro', label: 'Otro' },
];

export const SERVICE_STOP_ACTION_OPTIONS = SERVICE_TASK_OPTIONS.filter(
  (option) => option.value !== 'retiro_entrega'
);

export const resolveServiceTaskLabel = (value = '') =>
  SERVICE_TASK_OPTIONS.find((option) => option.value === String(value || '').trim())?.label || 'Servicio';

export const SERVICE_TYPE_OPTIONS = SERVICE_TRANSPORT_OPTIONS;

export const SERVICE_PRIORITY_OPTIONS = [
  { value: 'normal', label: 'Normal' },
  { value: 'alta', label: 'Alta' },
  { value: 'urgente', label: 'Urgente' },
];

export const SERVICE_TEMPLATE_FREQUENCY_OPTIONS = [
  { value: 'once', label: 'Única vez' },
  { value: 'weekly', label: 'Semanal' },
  { value: 'biweekly', label: 'Quincenal' },
  { value: 'monthly', label: 'Mensual' },
  { value: 'manual', label: 'A pedido' },
];

export const SERVICE_BILLING_CADENCE_OPTIONS = [
  { value: 'per_trip', label: 'Por viaje', description: 'Impacta venta y diferencia apenas se cierra la ruta.' },
  { value: 'weekly', label: 'Semanal acumulado', description: 'Acumula viajes y reconoce ventas/diferencia cuando el admin marca pago.' },
  { value: 'monthly', label: 'Mensual acumulado', description: 'Acumula viajes del período y reconoce el cobro al cierre mensual.' },
];

export const SERVICE_WEEKDAY_OPTIONS = [
  { value: 'monday', label: 'Lunes' },
  { value: 'tuesday', label: 'Martes' },
  { value: 'wednesday', label: 'Miércoles' },
  { value: 'thursday', label: 'Jueves' },
  { value: 'friday', label: 'Viernes' },
  { value: 'saturday', label: 'Sábado' },
  { value: 'sunday', label: 'Domingo' },
];

export const SERVICE_TRANSPORT_ASSIGNMENT_OPTIONS = [
  { value: 'free', label: 'Libre', description: 'Se activa sin transporte fijo y logística define la unidad.' },
  { value: 'suggested', label: 'Sugerida', description: 'Precompleta una unidad sugerida, pero se puede cambiar.' },
  { value: 'fixed', label: 'Fija', description: 'Ese contrato siempre nace con la misma unidad asignada.' },
];

export const SERVICE_DRIVER_ASSIGNMENT_OPTIONS = [
  { value: 'free', label: 'Libre', description: 'Logística define el chofer al momento de tomar el servicio.' },
  { value: 'suggested', label: 'Sugerido', description: 'Precompleta un chofer sugerido, pero se puede cambiar.' },
  { value: 'fixed', label: 'Fijo', description: 'Ese contrato siempre nace con el mismo chofer asignado.' },
];

export const buildClientDisplayName = (client = {}) => {
  const directName = String(
    client?.name ||
    client?.companyName ||
    client?.businessName ||
    client?.displayName ||
    ''
  ).trim();
  if (directName) return directName;

  const firstName = String(client?.firstName || client?.nombre || '').trim();
  const lastName = String(client?.lastName || client?.apellido || '').trim();
  const fullName = [firstName, lastName].filter(Boolean).join(' ').trim();
  if (fullName) return fullName;

  return 'Cliente sin nombre';
};
